const EmailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export function validateEmail(email) {
  let pattern = new RegExp(EmailRegex);
  if (pattern.test(email)) {
    return email;
  } else {
    return "";
  }
}



// WEBPACK FOOTER //
// ./src/utils/emailRegex.js